import React, { useRef, useState } from "react";
import Box from "../../../../components/Box";
import { Helpers } from "../../../../helpers/Helpers";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { useDispatch } from "react-redux";
import { storeAreYouSureModalCallback } from "../../../../redux/reducers/authSlice";
import CustomSwitch from "../../../../components/CustomSwitch";

export interface ConstantModel {
    constantId: string
    name: string | undefined
    code: string | undefined
    companyId: string | undefined
    isSelected: boolean
    isAdded: boolean
    createdUser?: string
    createdDate?: string
    updatedUser?: string
    updatedDate?: string
    isCustomActive: boolean
}

interface Props {
    constants: ConstantModel[]
    setConstants: React.Dispatch<React.SetStateAction<ConstantModel[]>>
}

const ConstantCategoryDetail = ({
    constants,
    setConstants
}: Props) => {
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const [constantId, setConstantId] = useState('');
    const [innerCode, setInnerCode] = useState<string | undefined>('');
    const [innerName, setInnerName] = useState<string | undefined>('');
    const [isConstantActive, setIsConstantActive] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const constantCategoryDetailRef: any = useRef();

    const saveItem = () => {
        if (Helpers.isEmpty(innerCode)) {
            toast.error('Kodu alanını doldurunuz!');
            return;
        }
        if (Helpers.isEmpty(innerName)) {
            toast.error('Posta Kodu Bitişi alanını doldurunuz!');
            return;
        }

        if (Helpers.isEmpty(constantId)) {
            var o: ConstantModel = {
                code: innerCode,
                name: innerName,
                constantId: Helpers.generateUUID(),
                isSelected: false,
                isAdded: true,
                companyId: auth.user.user?.data.isAdmin ? undefined : auth.selectedCompany?.companyId,
                isCustomActive: isConstantActive
            }

            setConstants([...constants, o])
        }
        else {
            setConstants(constants.map(function (x) {
                if (x.constantId == constantId) {
                    x.name = innerName;
                    x.code = innerCode;
                    x.isCustomActive = isConstantActive;
                    x.isSelected = false;
                }

                return x;
            }))
        }

        setConstantId('');
        setInnerCode('');
        setInnerName('');
        setIsConstantActive(true);
        setIsOpen(false);
        scrollTo();
    }

    const setItemSelected = (_id: string) => {
        setConstants(constants.map(function (x) {
            if (x.constantId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const selectAll = () => {
        var isAllSelected = constants.filter(x => auth.user.user?.data.isAdmin || x.companyId == auth.selectedCompany?.companyId).length == constants.filter(x => x.isSelected && (auth.user.user?.data.isAdmin || x.companyId == auth.selectedCompany?.companyId)).length;

        setConstants(constants.map(function (x) {
            if (auth.user.user?.data.isAdmin || x.companyId == auth.selectedCompany?.companyId)
                x.isSelected = !isAllSelected;

            return x;
        }))
    }

    const deleteItems = () => {
        setConstants(constants.filter(x => !x.isSelected));
    }

    const setUpdateItem = () => {
        var o = constants.filter(x => x.isSelected)[0];

        setConstantId(o.constantId);
        setInnerName(o.name);
        setInnerCode(o.code);
        setIsConstantActive(o.isCustomActive);
        setIsOpen(true);
        scrollTo();
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setConstantId('');
        setInnerCode('');
        setInnerName('');
        setIsConstantActive(true);
        setIsOpen(false);
        scrollTo();
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = constantCategoryDetailRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    return (
        <div ref={constantCategoryDetailRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Detay Bilgileri</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Kodu</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={innerCode} onChange={(e) => setInnerCode(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Adı</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={innerName} onChange={(e) => setInnerName(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>

                                        <CustomSwitch isActive={isConstantActive} setIsActive={setIsConstantActive} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={constants.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={constants.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>


                        <Box onClick={constants.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={constants.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={constants.filter(x => x.isSelected).length > 0 && constants.filter(x => (auth.user.user?.data.isAdmin || x.companyId == auth.selectedCompany?.companyId) && x.isSelected).length == constants.filter(x => auth.user.user?.data.isAdmin || x.companyId == auth.selectedCompany?.companyId).length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Kodu</th>
                                            <th>Adı</th>
                                            <th>Aktif</th>
                                            <th>Oluşturan</th>
                                            <th>Güncelleyen</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            constants.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            constants.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        {
                                                            (auth.user.user?.data.isAdmin || item.companyId == auth.selectedCompany?.companyId) && (
                                                                <div className='d-flex'>
                                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                        <input onChange={() => setItemSelected(item.constantId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                    </label>
                                                                </div>
                                                            )
                                                        }
                                                    </td>
                                                    <td>{item.code}</td>
                                                    <td>{item.name}</td>
                                                    <td>{item.isCustomActive ? <i style={{ fontSize: 20 }} className="text-success fa fa-check-circle" /> : <i style={{ fontSize: 20 }} className="text-danger fa fa-times-circle" />}</td>
                                                    <td>{item.createdUser} - {item.createdDate}</td>
                                                    <td>{item.updatedUser} - {item.updatedDate}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default ConstantCategoryDetail;